var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toggle-button-group"},_vm._l((_vm.ratios),function(ratio){return _c('button',{key:ratio.value,class:{ 'is-active': _vm.isActive(ratio.value) },on:{"click":function($event){return _vm.update(ratio.value)}}},[_vm._v(" "+_vm._s(ratio.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }